import { render, staticRenderFns } from "./DataDisplay.vue?vue&type=template&id=47d6fd7f&scoped=true&"
import script from "./DataDisplay.vue?vue&type=script&lang=js&"
export * from "./DataDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DataDisplay.vue?vue&type=style&index=0&id=47d6fd7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6fd7f",
  null
  
)

export default component.exports